module.exports = __webpack_public_path__ + "img/BiHelix(RGB-LN).0a20ef9a.png";